import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-amount-input',
  templateUrl: './amount-input.component.html',
  styleUrl: './amount-input.component.scss',
  standalone: false
})
export class AmountInputComponent implements OnInit {
  @Input() inputClass?: string;
  @Input() inputControlName!: string;
  @Input() inputFormGroup!: AbstractControl;
  @Input() submitButton?: Button;
  @Input() addon?: string;

  constructor() {
    if (this.inputFormGroup && this.inputControlName) {
      const inputControlName = this.inputControlName;
      this.getFormGroup(this.inputFormGroup).addControl(inputControlName, new FormControl(''));
    }
  }

  ngOnInit() {
    this.formatInput();
  }

  getFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  formatInput() {
    const control = this.inputFormGroup.get(this.inputControlName);
    if (!control || !control.value) return;

    const oldValue = control.value;
    const newValue = typeof oldValue === 'string' ? this.transform(oldValue) : oldValue;

    if (newValue !== oldValue) {
      control.setValue(newValue, { emitEvent: false });
    }
  }

  private transform(input: string): number {
    const lowerValue = input.toLowerCase().replace(',', '.');

    if (lowerValue.includes('m')) return parseFloat(lowerValue) * 1_000_000;
    if (lowerValue.includes('t') || lowerValue.includes('k')) return parseFloat(lowerValue) * 1_000;

    return parseFloat(lowerValue.replace(/\./g, '')) || 0;
  }
}
